import { render, staticRenderFns } from "./templateContent.vue?vue&type=template&id=305677c9&"
import script from "./templateContent.vue?vue&type=script&lang=ts&"
export * from "./templateContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports